import { IQService } from 'angular'
import { StateService } from 'angular-ui-router'
import moment from 'moment'
import { EmployeeService, PayrollService, TimeEntryService, IcdCorporationService } from '../../../core/services'
import { PermissionGrantService } from '../../../core/services/data-services/permission-grant.service'
import { UtilityService } from '../../../core/services/utility.service'
import { TimeGapDecorator } from '../time-gap-decorator.service'
import templateUrl from './list-time-entries-exceptions-container.component.html'

const tabIndices = {
    pending: 0,
    workedon: 1,
    processed: 2
};

export const ListTimeEntriesExceptionsContainerComponent = {
    templateUrl,
    controller: ListTimeEntriesExceptionsContainerController,
    controllerAs: "vm",
    bindings: {
        icdCorporationID: "<?"

    }
}



function ListTimeEntriesExceptionsContainerController($q: IQService, $uibModal: any, $state: StateService,
    employeeService: EmployeeService, utilityService: UtilityService, payrollService: PayrollService, icdCorporationService: IcdCorporationService,
    payrollDashboardService, permissionGrantService: PermissionGrantService, timeGapDecorator: TimeGapDecorator, timeEntryService: TimeEntryService, apexApiUrl: string) {
    'ngInject'

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = onInit;
    vm.exceptions;
    vm.pendingExceptions;
    vm.workingExceptions;
    vm.processedExceptions;
    vm.loadPending = loadPending;
    vm.loadWorking = loadWorking;
    vm.loadProcessed = loadProcessed;
    vm.selectedTab;
    vm.pendingExceptions;
    vm.workedExceptions;
    vm.processedExceptions;
    vm.tabIndices;
    vm.viewPayroll = viewPayroll;
    vm.viewTimeEntry = viewTimeEntry;
    vm.onChangeStatus = onChangeStatus;


    function onInit() {
        $q.when()
            .then(function () {
                vm.tabIndices = tabIndices;
                vm.selectedTab = tabIndices.pending;
                utilityService.showLoading();
                const load = $q.all([
                    vm.loadPending(),
                    vm.loadWorking(),
                    vm.loadProcessed()
                ]);
                utilityService.showLoadingUntilResolved(load);
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.loaded = true;
                utilityService.hideLoading();
            });
    }
    function loadPending() {
        var query = {
            IsPending: true,
            IsProcessed: false,
            IsWorking: false
        };
        return loadData(query).then((result) => {
            vm.pendingExceptions = result;
        });
    }

    function loadWorking() {
        var query = {
            IsPending: false,
            IsWorking: true,
            IsProcessed: false
        };
        return loadData(query).then((result) => {
            vm.workingExceptions = result;
        });
    }

    function loadProcessed() {
        var query = {
            IsPending: false,
            IsWorking: false,
            IsProcessed: true
        };
        return loadData(query).then((result) => {
            vm.processedExceptions = result;
        });
    }

    function loadData(query) {
        return timeEntryService.retrieveTimeEntryExceptions(query);
    }

    function onChangeStatus(batchID, status) {
        const update = timeEntryService.updateTimeEntryException(batchID, status).then((result) => {
            return $q.all([
                vm.loadPending(),
                vm.loadWorking(),
                vm.loadProcessed()
            ]);
        });
        utilityService.showLoadingUntilResolved(update)
    }

    function viewPayroll(payrollID) {
        $state.go("payroll.entry.edit", { payrollID });
    }

    function viewTimeEntry(icdCorporationID, startDate, endDate) {
        const parameter: any = {};
        parameter.startDate = moment(startDate).format('YYYY-MM-DD');
        parameter.endDate = moment(endDate).format('YYYY-MM-DD');
        parameter.currDate = null;
        parameter.icdCorporationID = icdCorporationID;

        $state.go("timeEntry.reviewPayPeriods", parameter);
    }





}
